<template>
  <div id="MyWallet">
    <div class="mywallet-content">
      <subTitle
        :title="
          searcher.walletType == 'DEFAULT'
            ? $t('我的余额')
            : searcher.walletType == 'JX_JG_DEFAULT'
            ? $t('我的余额')
            : searcher.walletType == 'BJ_JG_DEFAULT'
            ? $t('我的余额')
            : searcher.walletType == 'GZ_JG_DEFAULT'
            ? $t('我的余额')
            : $t('我的返佣')
        "
      ></subTitle>
      <ul class="tabs" v-if="tabList.length !== 1">
        <li v-for="(item, index) in tabList" :key="index" :class="activeName == item.val ? 'active' : ''" @click="changeActive(item.val)">
          {{ item.name }}
        </li>
      </ul>

      <div class="balance-bar" style="width: 1050px">
        <div class="title">
          {{ $t('当前余额:') }}<span>{{ walletObj.aggregateBalance.toFixed(2) }}</span> <span class="unit">{{ $t('元') }}</span>

          <es-button
            type="primary"
            @click="dialogTableVisible = true"
            class="mar-right-0"
            style="margin-left: 20px"
            v-if="walletObj.walletResultList.length > 1"
            >{{ $t('提现') }}</es-button
          >
          <es-button type="primary" @click="handleApplyCash" class="mar-right-0" style="margin-left: 20px" v-else>{{
            $t('提现')
          }}</es-button
          ><!-- 对话框 -->

          <es-dialog :title="$t(`提现明细`)" :visible.sync="dialogTableVisible" :width="'650px'">
            <es-table :data="gridData">
              <es-table-column property="companyName" :label="$t(`资金账户`)" width="300"></es-table-column>
              <es-table-column property="aggregateBalance" :label="$t(`余额（元）`)" width="180"></es-table-column>
              <es-table-column width="120">
                <template slot-scope="scope">
                  <es-radio
                    :label="scope.$index"
                    v-model="radio"
                    style="color: #fff; padding-left: 10px; margin-right: -25px"
                    @change="getCurrentRow(scope.row)"
                    :disabled="scope.row.companyCode === 'HealthSP'"
                    >{{ '' }}
                  </es-radio>
                </template>
              </es-table-column>
            </es-table>
            <div slot="footer">
              <es-button variant="outline" @click="dialogTableVisible = false">{{ $t('取消') }}</es-button>
              <es-button type="primary" @click="handleApplyCash">{{ $t('提现') }}</es-button>
            </div>
          </es-dialog>
        </div>
        <div class="title" v-if="searcher.walletType == 'DEFAULT'">
          {{ $t('可用余额:') }}<span>{{ walletObj.balance.toFixed(2) }}</span> <span class="unit">{{ $t('元') }}</span
          ><!-- 详情 -->

          <es-dropdown trigger="click" v-if="walletObj.walletResultList.length > 1">
            <span class="es-dropdown-link" style="font-size: 12px">{{ $t('详情') }}<i class="es-icon-arrow-down es-icon--right"></i> </span>
            <es-dropdown-menu slot="dropdown">
              <es-dropdown-item v-for="(item, index) in walletObj.walletResultList" :key="index" style="font-size: 14px; margin: 10px 15px"
                >{{ item.companyName }}<span style="padding: 10px"> </span>{{ item.balance.toFixed(2) }}{{ $t('元') }}</es-dropdown-item
              >
            </es-dropdown-menu>
          </es-dropdown>
        </div>
        <div class="title">
          {{ $t('提现中：') }}<span>{{ walletObj.freezeBalance.toFixed(2) }}</span> <span class="unit">{{ $t('元') }}</span
          ><!-- 详情 -->

          <es-dropdown trigger="click" v-if="walletObj.walletResultList.length > 1">
            <span class="es-dropdown-link" style="font-size: 12px">{{ $t('详情') }}<i class="es-icon-arrow-down es-icon--right"></i> </span>
            <es-dropdown-menu slot="dropdown">
              <es-dropdown-item v-for="(item, index) in walletObj.walletResultList" :key="index" style="font-size: 14px; margin: 10px 15px"
                >{{ item.companyName }}<span style="padding: 10px"></span>{{ item.freezeBalance.toFixed(2)
                }}{{ $t('元') }}</es-dropdown-item
              >
            </es-dropdown-menu>
          </es-dropdown>
        </div>
      </div>

      <div class="page-content">
        <div class="search-bar" style="display: flex; flex-wrap: wrap; justify-content: space-between; padding-bottom: 10px">
          <div>
            <p class="e-label margin-right-10">{{ $t('状态：') }}</p>
            <es-radio-group v-model="searcher.type" outline class="radio-group">
              <es-radio-button label>{{ $t('全部') }}</es-radio-button>
              <es-radio-button :label="true">{{ $t('收入') }}</es-radio-button>
              <es-radio-button :label="false">{{ $t('支出') }}</es-radio-button>
            </es-radio-group>
          </div>
          <div style="display: flex; flex-wrap: no-wrap; justify-content: space-between">
            <p class="e-label margin-right-10">{{ $t('时间：') }}</p>
            <es-radio-group v-model="searcher.date" outline class="radio-group" @change="shortcutSelect">
              <es-radio-button :label="null">{{ $t('全部') }}</es-radio-button>
              <es-radio-button label="month">{{ $t('1个月') }}</es-radio-button>
              <es-radio-button label="halfYear">{{ $t('半年') }}</es-radio-button>
              <es-radio-button label="aYear">{{ $t('1年') }}</es-radio-button>
            </es-radio-group>
            <es-date-picker
              @change="handleDatePickerChange"
              v-model="time"
              :value-format="'timestamp'"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t(`开始日期`)"
              :end-placeholder="$t(`结束日期`)"
              style="margin-right: 10px"
            >
            </es-date-picker>
          </div>
          <!-- 多主体钱包显示 -->

          <div class="width-200" v-if="walletObj.walletResultList.length > 1">
            <p class="e-label margin-right-10">{{ $t('资金账户：') }}</p>
            <es-select v-model="value" multiple filterable allow-create default-first-option :placeholder="$t(`资金账户`)">
              <es-option
                v-for="item in walletObj.walletResultList"
                :key="item.companyCode"
                :label="item.companyName"
                :value="item.companyCode"
              >
              </es-option>
            </es-select>
          </div>
          <div style="flex-grow: 2; justify-content: flex-end">
            <es-button @click="search()" type="primary">{{ $t('查询') }}</es-button>
            <es-button variant="outline" @click="reset()">{{ $t('清空') }}</es-button>
          </div>
        </div>
        <div class="table-content">
          <es-table
            v-loading="tableLoading"
            header-row-class-name="table-header"
            style="width: 100%"
            :data="tableData"
            :cell-style="timeStyle"
            header-theme="default"
          >
            <template slot="empty"
              ><es-empty
                style="margin: 25px; color: #999; line-height: 40px"
                :description="$t(`暂无更多数据`)"
                image="data:image/png;base64,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"
              ></es-empty>
            </template>
            <es-table-column prop="flowId" :label="$t(`流水号`)"></es-table-column>
            <es-table-column prop="createDate" :label="$t(`日期`)">
              <template slot-scope="scope">
                <p>{{ scope.row.createDate | formatDate }}</p>
              </template> </es-table-column
            ><!-- 多主体钱包显示 -->

            <es-table-column prop="companyName" :label="$t(`资金账户`)" v-if="walletObj.walletResultList.length > 1"> </es-table-column>
            <es-table-column :label="$t(`收入(元)`)" class="right">
              <template slot-scope="scope">
                <p class="earning" v-if="scope.row.amount > 0">+{{ scope.row.amount.toFixed(2) }}</p>
              </template>
            </es-table-column>
            <es-table-column :label="$t(`支出(元)`)">
              <template slot-scope="scope">
                <p class="expenditure" v-if="scope.row.amount < 0">{{ scope.row.amount.toFixed(2) }}</p>
              </template>
            </es-table-column>
            <es-table-column prop="balance" :label="$t(`余额(元)`)"></es-table-column>
            <es-table-column prop="payModeText" :label="$t(`支付方式`)"></es-table-column>
            <es-table-column prop="project" :label="$t(`项目`)">
              <template slot-scope="scope">
                <p>{{ projectDict[scope.row.action] }}</p>
              </template>
            </es-table-column>
            <es-table-column :label="$t(`详情`)">
              <template slot-scope="scope">
                <div>
                  <p
                    class="link-style"
                    @click="linkTo('/Order?payOrderId=' + scope.row.payOrderId)"
                    v-if="(scope.row.action == 'PAY_FOR_PRODUCT' || scope.row.action == 'CLOSE_AN_ACCOUNT') && scope.row.amount <= 0"
                  >
                    {{ $t('查看详情') }}
                  </p>
                  <p v-else>{{ scope.row.desc }}</p>
                </div>
              </template>
            </es-table-column>
          </es-table>

          <es-pagination
            style="text-align: right; margin-top: 20px"
            @current-change="currentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          ></es-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'
import subTitle from '@/components/subTitle'

function getAMonthAgo() {
  const now = new Date()

  return new Date(now.setMonth(now.getMonth() - 1)).getTime()
}

function getHalfYearAgo() {
  const now = new Date()

  return new Date(now.setMonth(now.getMonth() - 6)).getTime()
}

function getAYearAgo() {
  const now = new Date()

  return new Date(now.setFullYear(now.getFullYear() - 1)).getTime()
}

export default {
  name: 'MyWallet',
  components: {
    subTitle,
  },
  data() {
    return {
      time: '',
      gridData: [],
      dialogTableVisible: false,
      formLabelWidth: '120px',
      radio: '',
      searcher: {
        date: null,
        startDate: null,
        endDate: null,
        walletType: this.$route.name === 'MyWallet' ? 'DEFAULT' : 'COOP_BONUS',
        type: '',
        companyCode: '',
      },
      walletObj: {
        companyName: '',
        aggregateBalance: 0,
        balance: 0,
        freezeBalance: 0,
        walletResultList: [],
      },
      tableLoading: false,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      projectDict: {
        PAY_FOR_PRODUCT: $t('购买产品'),
        ONLINE_TOP_UP: $t('线上充值'),
        CLOSE_AN_ACCOUNT: $t('消费结算'),
        OFFLINE_TOP_UP: $t('线下充值'),
        WITHDRAW_DEPOSIT: $t('提现成功'),
        EXPRESS_FEE_OF_BILL: $t('发票快递费'),
        AGENT_REBATE: $t('代理返佣'),
        REFUND: $t('线下退款'),
        COOP_BONUS: $t('渠道合作'),
        REFUND_TOP_UP: $t('退款转入'),
      },
      value: [],
      tabs: [
        {
          text: $t(' 余额钱包'),
          value: 'DEFAULT',
        },
        {
          text: $t(' 返佣钱包'),
          value: 'COOP_BONUS',
        },
      ],

      // showCoopBonuns: false,
      tabList: [
        {
          name: $t('我的余额'),
          val: 0,
        },
      ],

      activeName: 0,
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.userInfo.isAdmin,
    }),
  },
  filters: {
    formatDate(val) {
      if (!val) return '--'
      const curTime = new Date(val)
      const yyyy = curTime.getFullYear()
      const MM = curTime.getMonth() + 1 < 10 ? `0${curTime.getMonth() + 1}` : curTime.getMonth() + 1
      const dd = curTime.getDate() < 10 ? `0${curTime.getDate()}` : curTime.getDate()

      const hh = curTime.getHours() < 10 ? `0${curTime.getHours()}` : curTime.getHours()
      const mm = curTime.getMinutes() < 10 ? `0${curTime.getMinutes()}` : curTime.getMinutes()
      const ss = curTime.getSeconds() < 10 ? `0${curTime.getSeconds()}` : curTime.getSeconds()

      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`
    },
  },

  async created() {
    this.search()
    this.handleGetAccountAmount()
  },

  mounted() {
    this.getMyBankInfo()
    this.getNav() // 获取返佣权限
  },
  methods: {
    async getNav() {
      const showCoopBonuns = await this.getWallet()
      if (showCoopBonuns) {
        this.tabList.push({
          name: $t('我的返佣'),
          val: 1,
        })
      }
    },
    getWallet() {
      return new Promise((resolve, reject) => {
        this.$ajax(
          this.$url.getAccountWalletAmount(),
          {
            walletType: 'COOP_BONUS',
          },
          false
        )
          .then(res => {
            resolve(res.data.ifExist)
          })
          .catch(() => {
            resolve(false)
          })
      })
    },
    changeActive(val) {
      this.activeName = val
    },
    getCurrentRow(data) {
      // 单选框获取当前行数据
      this.searcher.walletType = data.walletType
      this.companyCode = data.companyCode
      this.companyName = data.companyName
      this.balance = data.balance
      this.freezeBalance = data.freezeBalance
    },
    timeStyle(column) {
      const arr = [2, 3, 4]
      if (arr.includes(column.columnIndex)) {
        return 'text-align: right'
      }
      if (column.columnIndex === 5) {
        return 'padding-left:20px'
      }
    },
    async handleGetAccountAmount() {
      this.walletObj = await this.getAccountAmount(this.searcher.walletType)
    },
    // 获取账户钱包余额
    getAccountAmount(walletType) {
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getAccountWalletAmount(), {
          walletType,
        }).then(res => {
          this.gridData = res.data.walletResultList
          resolve(res.data)
        })
      })
    },
    // 时间的选项
    shortcutSelect() {
      this.searcher.startDate = null
      this.searcher.endDate = null
    },
    // 日期
    handleDatePickerChange(v) {
      if (v) {
        this.searcher.date = null
        this.searcher.startDate = v[0]
        this.searcher.endDate = v[1] + 86400000
      } else {
        this.searcher.startDate = null
        this.searcher.endDate = null
      }
    },
    // 搜索
    search() {
      this.tableLoading = true
      const params = {}
      // params.guid = ''  params.walletType = this.searcher.walletType
      params.type = this.searcher.type
      switch (this.searcher.date) {
        case 'month':
          // 查询开始时间
          params.startDate = getAMonthAgo()
          // 查询结束时间
          params.endDate = new Date().getTime()
          break
        case 'halfYear':
          // 查询开始时间
          params.startDate = getHalfYearAgo()
          // 查询结束时间
          params.endDate = new Date().getTime()
          break
        case 'aYear':
          // 查询开始时间
          params.startDate = getAYearAgo()
          // 查询结束时间
          params.endDate = new Date().getTime()
          break
        default:
          // 查询开始时间
          params.startDate = this.searcher.startDate || null
          // 查询结束时间
          params.endDate = this.searcher.endDate || new Date().getTime()
          break
      }

      // 类型:{1:充值,0:支付}
      // params.isTopUp = 1
      // 每页数量
      params.pageSize = this.pageSize
      // 下标
      params.offset = (this.currentPage - 1) * this.pageSize

      params.companyCode = this.value.join(',')

      // 排序字段
      // params.orderBy = 'create_date desc'

      // 账户明细列表
      this.$ajax(this.$url.getUserAccountList(), params)
        .then(res => {
          this.tableData = res.data.list
          this.totalCount = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    // 重置
    reset() {
      this.searcher.date = null
      this.searcher.startDate = null
      this.searcher.endDate = null
      this.currentPage = 1
      this.searcher.type = ''
      this.value = []
      this.search()
    },
    // 当前页
    currentChange(val) {
      this.currentPage = val
      // this.currentPage++
      this.search()
    },
    handleRecharge() {
      this.$router.push({
        path: '/MyWallet/Recharge',
      })
    },
    // 提现
    async handleApplyCash() {
      this.dialogFormVisible = false
      this.dialogTableVisible = false
      if (!this.isAdmin) {
        return this.$message.error($t('您还不是超级管理员，无法进行提现操作！'))
      }
      const todayCanApply = await this.getIsTodayApply()
      if (!todayCanApply) {
        return this.$message.error($t('为保障您主体账户资金安全，当天仅能操作1次提现，今日提现次数已用完！'))
      }
      const walletObj = await this.getAccountAmount(this.searcher.walletType)
      if (walletObj.balance < 1) {
        this.$message.error($t('您的可提现金额小于 1 元，不可提现！'))

        return (this.walletObj = walletObj)
      }
      if (walletObj.walletResultList.length > 1) {
        this.$router.push({
          path: '/applyCash',
          query: {
            type: this.searcher.walletType,
            companyName: this.companyName,
            freezeBalance: this.freezeBalance,
            balance: this.balance,
          },
        })
      } else {
        this.$router.push({
          path: '/applyCash',
          query: {
            type: this.searcher.walletType,
            companyName: this.gridData[0].companyName,
            freezeBalance: this.gridData[0].freezeBalance,
            balance: this.gridData[0].balance,
          },
        })
      }
    },
    // 当天是否可提现
    getIsTodayApply() {
      const { companyCode } = this

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getIsTodayApply(), { companyCode })
          .then(res => {
            resolve(res.data.ifSuccess)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 查看详情
    linkTo(arg) {
      this.$router.push({
        path: arg,
      })
    },
    // 获取最后一次提现结果
    getMyBankInfo() {
      this.$ajax(this.$url.getMyBankInfo(true), {}).then(res => {
        if (res.code === 0 && res.data && this.isAdmin && res.data.refundFlag === 'DEFAULT') {
          if (['REJECT', 'FAIL'].includes(res.data.applicationStatus)) {
            this.$message({
              message: $t('您于{slot1}发起的提现申请失败，失败原因为：{slot2}。', { slot1: res.data.createDate, slot2: res.data.message }),
              duration: 10000,
              type: 'error',
              customClass: 'custom-message-class',
              showClose: true,
              onClose: () => {
                this.$ajax(this.$url.markFailedTip(res.data.applicationId), {})
                  .then(res => {})
                  .catch(err => {
                    this.$message.error(err)
                  })
              },
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.tabs {
  display: flex;
  margin: 10px 24px;
  border-bottom: 1px solid #00000017;
  > li {
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000a6;
    height: 40px;
    line-height: 40px;
    min-width: 102px;
    width: auto;
  }
  li.active {
    border-bottom: 2px solid #1063f1;
    color: #1063f1;
    font-weight: 600;
  }
  li:hover {
    color: #1063f1;
  }
}

.mywallet-content {
  .balance-bar {
    height: 64px;
    display: flex;
    padding: 0 24px;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 24px;
      margin: 0 8px;
    }
    .unit {
      color: #333333;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .page-content {
    .search-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 42px;
      div {
        display: flex;
        align-items: center;
      }

      .es-radio-group {
        margin-right: 10px;
      }
    }

    .table-content {
      margin-top: 20px;
      padding: 0 24px;
      .earning {
        color: #f55308;
      }
    }
  }

  /deep/.es-empty__image {
    width: 64px;
  }

}

.margin-right-10 {
  margin-right: 10px;
}

.margin-0-6 {
  margin: 0 6px;
}

.e-label {
  color: #555b65;
}

.color-efefef {
  color: #efefef;
}

.link-style {
  color: #1875f0;

  cursor: pointer;
}
</style>
<style>

.table-header th:nth-child(3) {
  text-align: right;
}

.table-header th:nth-child(4) {
  text-align: right;
}

.table-header th:nth-child(5) {
  text-align: right;
}

.table-header th:nth-child(6) {
  padding-left: 20px;
}
</style>
